module.exports = __webpack_public_path__ + "static/media/statistic.9c85176c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/statistic.svg
// module id = 189
// module chunks = 0